import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { getUsePrimaryUrlParams } from "../../utils/utils";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const updateCreationWebhook = (axios: IAxiosInstance) => {
  return async ({
    workerCreatedWebhook,
    userType,
    usePrimary,
    isTestWebhookType,
  }: ISchema["#/definitions/IUpdateCreationWebhookArgs"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/IUpdateCreationWebhookResponse"]
    >(`/api/updateCreationWebhook${getUsePrimaryUrlParams(usePrimary)}`, {
      worker_created_webhook: workerCreatedWebhook,
      user_type: userType,
      is_test_webhook_type: isTestWebhookType,
    });

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
